module.exports = __webpack_public_path__ + "img/facadaisa1.70211ecc.png";